import React, { useEffect, useRef } from "react";
import { TestType } from "../../models/Enums";
import { Chart, ChartConfiguration, registerables } from "chart.js";

interface Props {
  graphDetails: TrendlineGraphDetails;
  setSelectedIndex: Function;
  setIsGraphClicked: Function;
  circleClicked: Function;
  yMappings: Record<number, string> | null;
  allowNegative?: boolean;
  isReportGraph?: boolean;
  vbTestLookupId?: number;
  currentMetric?: number;
}

interface TrendlineGraphDetails {
  assessmentType: TestType;
  graphSvg: React.ReactNode;
  lineGraphValues: any;
  RangeIds: string[];
}

const TrendlineGraph: React.FC<Props> = ({
  graphDetails,
  setSelectedIndex,
  setIsGraphClicked,
  circleClicked,
  yMappings,
  allowNegative,
  isReportGraph,
  vbTestLookupId,
  currentMetric,
}) => {
  const blueImagee: any = "../../../../assets/images/pointer.png";
  const orangeImagee: any = "../../../../assets/images/play-icon.png";
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const canvass = useRef<HTMLElement | null>(
    document.getElementById("lineChart"),
  );
  let chartline: Chart;
  const selectedPointIndexRef = useRef<any>(null);

  useEffect(() => {
    debugger;
    console.log("vbTestLookupId: ", vbTestLookupId);
    console.log("currentMetric: ", currentMetric);
    console.log("Graph Details are: ", graphDetails);
    console.log("Y mappings are: ", yMappings);
    if (
      graphDetails &&
      graphDetails.RangeIds &&
      graphDetails.RangeIds.length !== 0
    ) {
      selectedPointIndexRef.current = graphDetails.RangeIds.length - 1;
    }
    Chart.register(...registerables);
    createLineGraph();
  }, []);

  useEffect(() => {
    console.log(
      "useEffect called for TrendlineGraph. Graph Details are: ",
      graphDetails,
    );
    debugger;
    const handleCanvasClick = (evt: MouseEvent) => {
      if (!chartline) return;

      console.log("Handle canvas click");

      const res = chartline.getElementsAtEventForMode(
        evt,
        "point",
        { intersect: true },
        true,
      );

      selectedPointIndexRef.current = null;
      const clickedIndex = res ? res[0]?.index : null;
      selectedPointIndexRef.current = clickedIndex;
      setSelectedIndex(clickedIndex);
      setIsGraphClicked(true);
      circleClicked(clickedIndex);

      if (clickedIndex !== undefined && res.length > 0) {
        assesmentValueSet(clickedIndex);
      }
    };

    const canvas = canvasRef.current;
    if (canvas) {
      canvas.addEventListener("click", handleCanvasClick);
    }

    return () => {
      if (canvas) {
        canvas.removeEventListener("click", handleCanvasClick);
      }
      if (chartline) {
        chartline.destroy();
      }
    };
  }, []); // Dependency on chartline if needed

  const highlightSelectedDate = () => {
    debugger;
    const chart = chartline;
    const ctx = chart.ctx;
    const xAxis = chart.scales["x"];

    // Clear previous highlights
    // Use getLabelItems method to check if labels exist
    const labelItems = xAxis.getLabelItems();
    if (!labelItems) {
      ctx.clearRect(0, 0, chart.width, chart.height);
    }

    // Draw the chart
    chart.draw();

    if (
      selectedPointIndexRef?.current !== null &&
      selectedPointIndexRef?.current !== undefined
    ) {
      ctx.shadowColor = "rgba(0, 0, 0, 0.1)"; // Use a light gray shadow color
      ctx.shadowBlur = 15; // Adjust the blur radius to your preference
      ctx.shadowOffsetX = 2; // Adjust the horizontal offset
      ctx.shadowOffsetY = 2; // Adjust the vertical offset
      ctx.fillStyle = "#01A7C2";
      ctx.save();

      if (labelItems && labelItems.length > selectedPointIndexRef?.current) {
        try {
          // Modify label options
          labelItems[selectedPointIndexRef?.current!].options.color = "black";
        } catch (ex: any) {
          console.log(ex);
        }
      }

      ctx.fillText(
        graphDetails.RangeIds[selectedPointIndexRef?.current!],
        xAxis.getPixelForValue(selectedPointIndexRef?.current!) -
          ctx.measureText(
            graphDetails.RangeIds[selectedPointIndexRef?.current!],
          ).width /
            2,
        xAxis.bottom + 20,
      );
    }

    ctx.font = "bold 20px";

    ctx.restore();
    chart.draw();
  };

  const createLineGraph = () => {
    const blueImage = new Image(16, 16); // Set the width and height accordingly
    blueImage.src = blueImagee;

    const orangeImage = new Image(16, 16);
    orangeImage.src = orangeImagee;
    // Destroy the existing chart before rendering a new one
    if (chartline) {
      chartline.destroy();
    }
    console.log("lineGraphValues: ", graphDetails.lineGraphValues);
    const canvas = canvasRef.current;

    let dataPoints = [];
    for (const value of graphDetails.lineGraphValues) {
      if (typeof value === "string") {
        let splitString = value.split(" ");
        let x = parseFloat(splitString[0]);
        if (isNaN(x)) {
          dataPoints.push(value);
        } else {
          dataPoints.push(x);
        }
      } else {
        dataPoints.push(value);
      }
    }

    let firstLineData, secondLineData, uniqueDates;
    // Split data into two separate datasets
    if (
      (vbTestLookupId === TestType.hec_training && currentMetric === 3) ||
      vbTestLookupId === TestType.game_AF ||
      (vbTestLookupId === TestType.reach && currentMetric === 2)
    ) {
      // For functional reach, data is already separated into two arrays
      if (
        vbTestLookupId === TestType.reach &&
        currentMetric === 2 &&
        Array.isArray(graphDetails.lineGraphValues[0])
      ) {
        firstLineData = graphDetails.lineGraphValues[0];
        secondLineData = graphDetails.lineGraphValues[1];
        uniqueDates = graphDetails.RangeIds;
      } else {
        firstLineData = graphDetails.lineGraphValues.filter(
          (_: any, index: any) => index % 2 === 0,
        );
        secondLineData = graphDetails.lineGraphValues.filter(
          (_: any, index: any) => index % 2 !== 0,
        );
        uniqueDates = graphDetails.RangeIds.filter(
          (date, index, array) => array.indexOf(date) === index,
        );
      }
      selectedPointIndexRef.current = uniqueDates.length - 1;
    }

    console.log("firstLineData: ", firstLineData);
    console.log("secondLineData: ", secondLineData);
    console.log("uniqueDates: ", uniqueDates);

    if (canvasRef && canvas) {
      const ctx = canvas.getContext("2d");
      if (ctx) {
        debugger;
        if (
          (vbTestLookupId === TestType.hec_training && currentMetric === 3) ||
          vbTestLookupId === TestType.game_AF ||
          (vbTestLookupId === TestType.reach && currentMetric === 2)
        ) {
          chartline = new Chart(ctx, {
            type: "line",
            data: {
              labels: uniqueDates,
              datasets: [
                {
                  label: "line1",
                  data: firstLineData,
                  backgroundColor: "rgba(148,159,177,0.2)",
                  borderColor: "#005A75",
                  pointBackgroundColor: (context: any) => {
                    const index = context.dataIndex;
                    return index === selectedPointIndexRef?.current &&
                      !isReportGraph
                      ? "#01A7C2"
                      : "#005A75";
                  },
                  pointBorderColor: (context: any) => {
                    const index = context.dataIndex;
                    return index === selectedPointIndexRef?.current
                      ? "#FFFFFF"
                      : "#FFFFFF";
                  },
                  pointHoverBackgroundColor: (context: any) =>
                    context.dataIndex === selectedPointIndexRef?.current
                      ? "#01A7C2"
                      : "#01A7C2",

                  pointHoverBorderColor: "#FFFFFF",
                  pointHoverBorderWidth: 5,
                  pointBorderWidth(context: any) {
                    if (!isReportGraph) {
                      return context.dataIndex ===
                        selectedPointIndexRef?.current
                        ? 3
                        : 5;
                    } else {
                      return 5;
                    }
                  },
                  borderWidth: 5,
                  pointRadius(context: any) {
                    if (!isReportGraph) {
                      return context.dataIndex ===
                        selectedPointIndexRef?.current
                        ? 8
                        : 10;
                    } else {
                      return 10;
                    }
                  },
                  pointHoverRadius: 10,
                  clip: false,
                },
                {
                  label: "line2",
                  data: secondLineData,
                  backgroundColor: "rgba(148,159,177,0.2)",
                  borderColor: "#9F3412",
                  pointBackgroundColor: (context: any) => {
                    const index = context.dataIndex;
                    return index === selectedPointIndexRef?.current &&
                      !isReportGraph
                      ? "#9F3412"
                      : "#9F3412";
                  },
                  pointBorderColor: (context: any) => {
                    const index = context.dataIndex;
                    return index === selectedPointIndexRef?.current
                      ? "#FFFFFF"
                      : "#FFFFFF";
                  },
                  pointHoverBackgroundColor: (context: any) =>
                    context.dataIndex === selectedPointIndexRef?.current
                      ? "#9F3412"
                      : "#9F3412",
                  pointHoverBorderColor: "#FFFFFF",
                  pointHoverBorderWidth: 5,
                  pointBorderWidth(context: any) {
                    if (!isReportGraph) {
                      return context.dataIndex ===
                        selectedPointIndexRef?.current
                        ? 3
                        : 5;
                    } else {
                      return 5;
                    }
                  },
                  borderWidth: 5,
                  pointRadius(context: any) {
                    if (!isReportGraph) {
                      return context.dataIndex ===
                        selectedPointIndexRef?.current
                        ? 8
                        : 10;
                    } else {
                      return 10;
                    }
                  },
                  pointHoverRadius: 10,
                  clip: false,
                },
              ],
            },
            options: {
              responsive: isReportGraph, // Prevent automatic resizing
              maintainAspectRatio: false, // Allow chart to fit its container
              tension: 0.3,
              layout: {
                padding: {
                  top: 40,
                },
              },
              plugins: {
                tooltip: {
                  enabled: false,
                },
                legend: {
                  display: false,
                },
              },
              scales: {
                y: {
                  display: true,
                  grid: {
                    offset: false, // Set to true to add padding
                  },
                  ticks: {
                    callback: (value: number, index: number) => {
                      debugger;

                      if (
                        vbTestLookupId === TestType.hec_training &&
                        currentMetric === 3
                      ) {
                        // Display only 5 ticks
                        const totalTicks = 5;
                        const maxValue = yMappings
                          ? Math.max(...Object.keys(yMappings).map(Number))
                          : 5; // Default max value
                        const step = maxValue / (totalTicks - 1);

                        // Show ticks only at specific intervals
                        if (value % step === 0) {
                          return yMappings
                            ? yMappings[value]
                            : Math.round(value * 10) / 10;
                        }
                        return ""; // Skip other ticks
                      } else {
                        // Default behavior
                        return yMappings
                          ? yMappings[value]
                          : Math.round(value * 10) / 10;
                      }
                    },
                    stepSize:
                      vbTestLookupId === TestType.hec_training &&
                      currentMetric === 2
                        ? 0.2
                        : 10, // Dynamically adjust stepSize
                  },
                  afterBuildTicks: (axis) => {
                    if (yMappings) {
                      debugger;
                      axis.ticks = Object.entries(yMappings).map(
                        ([key, label]) => ({
                          value: Number(key),
                          label: label,
                        }),
                      );
                      axis.max =
                        Math.max(
                          ...Object.entries(yMappings).map(([key, label]) =>
                            Number(key),
                          ),
                        ) + (yMappings ? 0.1 : 0);
                      axis.min = Math.min(
                        ...Object.entries(yMappings).map(([key, label]) =>
                          Number(key),
                        ),
                      );
                    }

                    if (!allowNegative) {
                      console.log("allowNegative is false");
                      axis.min = Math.max(0, axis.min);
                    }
                  },
                },
                x: {
                  grid: {
                    offset: true,
                  },
                  ticks: {
                    stepSize: Math.ceil(graphDetails.RangeIds.length / 10), // Adjust step size for spacing
                  },
                  title: {
                    display: isReportGraph,
                    text: isReportGraph ? "Seconds" : "",
                    font: {
                      size: 20,
                      weight: 400,
                    },
                  },
                },
              },
              animation: {
                onComplete: (chart: any) => {
                  if (chart) {
                    debugger;
                    console.log(
                      "Selected point: ",
                      selectedPointIndexRef?.current,
                    );
                    if (!isReportGraph) {
                      highlightSelectedDate();
                    }
                  }
                },
              },
              elements: {
                point: {
                  radius: 5, // Set the radius of points
                },
              },
            } as ChartConfiguration<"line">["options"], // Cast the options to the correct type
            plugins: [
              {
                id: "pointShadow",
                beforeDraw: (chart) => {
                  if (!chart.ctx || chart.tooltip?.active) return;
                  // Add this check to prevent unnecessary redraws
                  if (!chart.tooltip?.active) {
                    const ctx = chart.ctx;
                    chart.data.datasets.forEach((dataset, datasetIndex) => {
                      const meta = chart.getDatasetMeta(datasetIndex);
                      meta.data.forEach((point, pointIndex) => {
                        if (
                          pointIndex === selectedPointIndexRef?.current &&
                          !isReportGraph
                        ) {
                          // Colors based on dataset
                          const highlightColor =
                            vbTestLookupId === TestType.hec_training &&
                            currentMetric === 3
                              ? datasetIndex === 0
                                ? "#005A75"
                                : "#9F3412"
                              : vbTestLookupId === TestType.game_AF
                                ? datasetIndex === 0
                                  ? "#005A75"
                                  : "#9F3412"
                                : vbTestLookupId === TestType.reach &&
                                    currentMetric === 2
                                  ? datasetIndex === 0
                                    ? "#005A75"
                                    : "#9F3412"
                                  : "";
                          const shadowColor =
                            datasetIndex === 0
                              ? "rgba(159, 52, 18, 1)"
                              : "rgba(0, 90, 117, 1)";

                          // Outer ring
                          ctx.save();
                          ctx.beginPath();
                          ctx.lineWidth = 5;
                          ctx.strokeStyle = highlightColor;
                          ctx.arc(
                            point.x,
                            point.y,
                            point.options["radius"] + 3,
                            0,
                            Math.PI * 2,
                          );
                          ctx.stroke();
                          ctx.restore();

                          // Shadow effect
                          ctx.save();
                          ctx.shadowColor = shadowColor;
                          ctx.shadowBlur = 60;
                          ctx.shadowOffsetX = 0;
                          ctx.shadowOffsetY = 0;
                          ctx.beginPath();
                          ctx.arc(
                            point.x,
                            point.y,
                            point.options["radius"] + 3,
                            0,
                            Math.PI * 2,
                          );
                          ctx.fill();
                          ctx.restore();
                        }
                      });
                    });
                  }
                  drawDataLabels(chart);
                },
                afterDraw: (chart: any) => {
                  drawMultiDataLabels(chart);
                },
              },
            ],
          });
        } else {
          chartline = new Chart(ctx, {
            type: "line",
            data: {
              labels: graphDetails.RangeIds,
              datasets: [
                {
                  label: "line",
                  data: dataPoints,
                  backgroundColor: "rgba(148,159,177,0.2)",
                  borderColor: "#005A75",
                  pointBackgroundColor: (context: any) => {
                    const index = context.dataIndex;
                    return index === selectedPointIndexRef?.current &&
                      !isReportGraph
                      ? "#01A7C2"
                      : "#005A75";
                  },
                  pointBorderColor: (context: any) => {
                    const index = context.dataIndex;
                    return index === selectedPointIndexRef?.current
                      ? "#FFFFFF"
                      : "#FFFFFF";
                  },
                  pointHoverBackgroundColor: (context: any) =>
                    context.dataIndex === selectedPointIndexRef?.current
                      ? "#01A7C2"
                      : "#01A7C2",

                  pointHoverBorderColor: "#FFFFFF",
                  pointHoverBorderWidth: 5,
                  pointBorderWidth(context: any) {
                    if (!isReportGraph) {
                      return context.dataIndex ===
                        selectedPointIndexRef?.current
                        ? 3
                        : 5;
                    } else {
                      return 5;
                    }
                  },
                  borderWidth: 5,
                  pointRadius(context: any) {
                    if (!isReportGraph) {
                      return context.dataIndex ===
                        selectedPointIndexRef?.current
                        ? 8
                        : 10;
                    } else {
                      return 10;
                    }
                  },
                  pointHoverRadius: 10,
                  clip: false,
                },
              ],
            },
            options: {
              responsive: isReportGraph, // Prevent automatic resizing
              maintainAspectRatio: false, // Allow chart to fit its container
              tension: 1,
              layout: {
                padding: {
                  top: 40,
                },
              },
              plugins: {
                tooltip: {
                  enabled: false,
                },
                legend: {
                  display: false,
                },
              },
              scales: {
                y: {
                  display: true,
                  grid: {
                    offset: false, // Set to true to add padding
                  },
                  ticks: {
                    callback: (value: number, index: number) => {
                      if (vbTestLookupId === 21) {
                        debugger;
                        // Display only 5 ticks
                        const totalTicks = 5;
                        const maxValue = yMappings
                          ? Math.max(...Object.keys(yMappings).map(Number))
                          : 10; // Default max value
                        const step = maxValue / (totalTicks - 1);

                        // Show ticks only at specific intervals
                        if (value % step === 0) {
                          return yMappings
                            ? yMappings[value]
                            : Math.round(value * 10) / 10;
                        }
                        return ""; // Skip other ticks
                      }

                      // Default behavior
                      return yMappings
                        ? yMappings[value]
                        : Math.round(value * 10) / 10;
                    },
                    stepSize: vbTestLookupId === 21 ? 10000 : 1, // Dynamically adjust stepSize
                  },
                  afterBuildTicks: (axis) => {
                    if (yMappings) {
                      debugger;
                      axis.ticks = Object.entries(yMappings).map(
                        ([key, label]) => ({
                          value: Number(key),
                          label: label,
                        }),
                      );
                      axis.max =
                        Math.max(
                          ...Object.entries(yMappings).map(([key, label]) =>
                            Number(key),
                          ),
                        ) + (yMappings ? 0.1 : 0);
                      axis.min = Math.min(
                        ...Object.entries(yMappings).map(([key, label]) =>
                          Number(key),
                        ),
                      );
                    }

                    if (!allowNegative) {
                      console.log("allowNegative is false");
                      axis.min = Math.max(0, axis.min);
                    }
                  },
                },
                x: {
                  grid: {
                    offset: true,
                  },
                  ticks: {
                    stepSize: Math.ceil(graphDetails.RangeIds.length / 10), // Adjust step size for spacing
                  },
                  title: {
                    display: isReportGraph,
                    text: isReportGraph ? "Seconds" : "",
                    font: {
                      size: 20,
                      weight: 400,
                    },
                  },
                },
              },
              animation: {
                onComplete: (chart: any) => {
                  if (chart) {
                    debugger;
                    console.log(
                      "Selected point: ",
                      selectedPointIndexRef?.current,
                    );
                    if (!isReportGraph) {
                      highlightSelectedDate();
                    }
                    drawDataLabels(chart);
                  }
                },
              },
              elements: {
                point: {
                  radius: 5, // Set the radius of points
                },
              },
            } as ChartConfiguration<"line">["options"], // Cast the options to the correct type
            plugins: [
              {
                id: "pointShadow",
                beforeDraw: (chart) => {
                  if (!chart.ctx || chart.tooltip?.active) return;
                  // Add this check to prevent unnecessary redraws
                  if (!chart.tooltip?.active) {
                    const ctx = chart.ctx;
                    chart.data.datasets.forEach((dataset, datasetIndex) => {
                      const meta = chart.getDatasetMeta(datasetIndex);
                      meta.data.forEach((point, pointIndex) => {
                        // Draw additional ring around the selected point
                        if (
                          pointIndex === selectedPointIndexRef?.current &&
                          !isReportGraph
                        ) {
                          ctx.save();
                          ctx.beginPath();
                          ctx.lineWidth = 5; // Thickness of the outer ring
                          ctx.strokeStyle = "#01A7C2"; // Color of the outer ring
                          ctx.arc(
                            point.x,
                            point.y,
                            point.options["radius"] + 3,
                            0,
                            Math.PI * 2,
                          );
                          ctx.stroke();
                          ctx.restore();

                          ctx.save();
                          ctx.shadowColor = "rgba(1,167,194, 1)";
                          ctx.shadowBlur = 60;
                          ctx.shadowOffsetX = 0;
                          ctx.shadowOffsetY = 0;
                          ctx.beginPath();
                          ctx.arc(
                            point.x,
                            point.y,
                            point.options["radius"] + 3,
                            0,
                            Math.PI * 2,
                          );
                          ctx.fill();
                          ctx.restore();
                        }
                      });
                    });
                  }
                  drawDataLabels(chart);
                },
              },
            ],
          });
        }
        // Add this to stabilize the chart
        chartline.update("none");
      }
    }
  };

  function drawDataLabels(chart: any) {
    if (!chart || !chart.ctx) return;

    if (yMappings) return;

    const ctx = chart.chart ? chart.chart.ctx : chart.ctx;
    if (!ctx) return;

    chart.data.datasets[0].data.forEach((value: any, index: number) => {
      const point = chart.getDatasetMeta(0).data[index];
      if (point) {
        ctx.save();
        ctx.fillStyle = "#002E3C";
        ctx.font = "12px Arial";
        ctx.textAlign = "center";

        let labelValue = value;
        if (typeof value === "number") {
          labelValue = Math.round(value * 10) / 10;
        } else if (typeof value === "string") {
          let x = parseFloat(value);
          if (!isNaN(x)) {
            labelValue = Math.round(x * 10) / 10;
          }
        }

        ctx.fillText(
          !isReportGraph ? labelValue.toString() : "",
          point.x,
          point.y - 25,
        );
        ctx.restore();
      }
    });
  }

  function drawMultiDataLabels(chart: any) {
    const ctx = chart.ctx;
    const datasets = chart.data.datasets;

    ctx.save();
    ctx.font = "12px Arial";
    ctx.textAlign = "center";

    datasets.forEach((dataset: any, datasetIndex: number) => {
      const meta = chart.getDatasetMeta(datasetIndex);

      meta.data.forEach((point: any, index: number) => {
        // Set color based on dataset
        ctx.fillStyle = datasetIndex === 0 ? "#005A75" : "#9F3412";

        const value = dataset.data[index];
        const x = point.x;
        const y = point.y - 25;

        // Draw label
        ctx.fillText(value, x, y);
      });
    });

    ctx.restore();
  }

  const assesmentValueSet = (event: any) => {
    let AssessmentValue;
    if (event instanceof Event && event.target) {
      const targetElement = event.target as HTMLInputElement;
      if (targetElement.value !== undefined) {
        AssessmentValue = targetElement.value;
        selectedPointIndexRef.current = Number(targetElement.value);
        setSelectedIndex(Number(targetElement.value));
      }
    } else {
      AssessmentValue = event;
      selectedPointIndexRef.current = event;
      setSelectedIndex(event);
    }

    if (chartline.data.labels) {
      try {
        chartline.data.datasets[0].backgroundColor = chartline.data.labels.map(
          (_: any, index: number | null) =>
            index === event ? "#0E76BD" : "rgba(148,159,177,1)",
        );
      } catch (ex: any) {
        console.log("exception: ", ex);
      }

      chartline.data.datasets[0].backgroundColor = chartline.data.labels.map(
        (_: any, index: number | null) =>
          index === event ? "#0E76BD" : "#F78513",
      );
    }

    chartline.update();
  };

  return (
    <div id="chart-container" className="chart-canvas-wrapper">
      <canvas
        ref={canvasRef}
        id="lineChart"
        style={{
          width: `${
            graphDetails.RangeIds.length <= 4
              ? 100
              : (graphDetails.RangeIds.length - 4) * 20 + 100
          }%`,
          height: "100%",
        }}
      ></canvas>
    </div>
  );
};

export default React.memo(TrendlineGraph); // Prevent unnecessary re-renders
